import React, {useContext} from 'react';
import {IListConfigRelationColumn} from '@src/@interfaces/components/List/IListConfigRelationColumn';
import {ListConfigNamedColumn} from '@src/@types/components/List';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {parseDate} from '@src/helpers/dates';
import DatetimeColumn from '@src/components/List/columns/DatetimeColumn';
import {IOrderProductModel} from '@src/@interfaces/models/Order/IOrderProductModel';
import {DeadlineCounter} from '../orders/OrderListDeadlineAtColumn';
import {LocaleContext} from '@src/contexts/LocaleContext';

export default function OrderProductListDeadlineAtColumn(
        props: IListColumnProps<ListConfigNamedColumn<IListConfigRelationColumn>, IOrderProductModel>
) {
    useContext(LocaleContext);
    const date = (!props.model?.status?.is_completed && props.model?.deadline_at) ?
            parseDate(props.model?.deadline_at) :
            undefined;

    return <>
        <DatetimeColumn {...props}/>

        <DeadlineCounter
                date={date}
                titlePrefix="OrdersIndex.time-to-nearest-order-product-deadline"
                yellowColorSince={props.model.yellow_indicator_color_since}
                redColorSince={props.model.red_indicator_color_since}
        />
    </>;
}
